module.exports = __webpack_public_path__ + "02_long_brown.bb9d44d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_long_brown.png
// module id = IonG
// module chunks = 0